import { createBrowserRouter } from "react-router-dom";

import { NotFoundPage } from "@app/pages/error/NotFoundPage.tsx";
import { HomePage } from "@app/pages/HomePage";
import { MissionsPage } from "@app/pages/MissionsPage.tsx";
import { SettingsPage } from "@app/pages/SettingsPage.tsx";
import { UserPage } from "@app/pages/UserPage";
import { UsersPage } from "@app/pages/UsersPage";

export const AppRouter = createBrowserRouter([
  {
    path: "/",
    element: <HomePage />,
    children: [
      {
        index: true,
        element: <UsersPage />,
      },
      {
        path: "missions",
        element: <MissionsPage />,
      },
      {
        path: "users/:userId",
        element: <UserPage />,
      },
      {
        path: "settings",
        element: <SettingsPage />,
      },
      {
        path: "*",
        element: <NotFoundPage />,
      },
    ],
  },
]);
